export default "__VITE_ASSET__DMhN3bmy__"